import { ReactiveController, ReactiveControllerHost } from "lit";

export interface DismissConfig {
    surface: () => HTMLElement | null;
    anchor: () => HTMLElement | null;
    onDismiss: () => void;
}

export class DismissController implements ReactiveController {
    private host: ReactiveControllerHost;
    private config: DismissConfig;

    constructor(host: ReactiveControllerHost, config: DismissConfig) {
        this.host = host;
        this.config = config;

        this.host.addController(this);
    }

    hostConnected(): void {
        document.addEventListener('click', this.onDocumentClick, { capture: true });
        document.addEventListener('keydown', this.onKeyDown, { capture: true });
    }

    hostDisconnected(): void {
        document.removeEventListener('click', () => '', { capture: true });
        document.removeEventListener('keydown', () => '', { capture: true });
    }

    private onKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this.config.onDismiss();
        }
    }

    private onDocumentClick = (event: MouseEvent) => {
        const surfaceEl = this.config.surface();
        const anchorEl = this.config.anchor();


        if (!surfaceEl) return;

        const path = event.composedPath();
        const clickedInsideSurface = path.includes(surfaceEl);
        const clickedOnAnchor = anchorEl ? path.includes(anchorEl) : false;

        if (!clickedInsideSurface && !clickedOnAnchor) {
            this.config.onDismiss()
        }
    }

}